import job_preview_modal from "@/components/probaworkflows_base_components/JobPreviewModal/job_preview_modal/JobPreviewModal.vue";
import CreateAdvertModal from "@/components/probaworkflows_base_components/CreateAdvertModal/CreateAdvertModal.vue";
import EditAdvertModal from "@/components/probaworkflows_base_components/EditAdvertModal/EditAdvertModal.vue";
import ViewJobProfile from "@/views/probaworkflows_base/recruitment/view_job_profile/ViewJobProfile.vue";
import ManageJobProfilesList from "./ManageJobProfilesList.vue";
import { JOB_VISIBILITY_PRIVATE, get_headers, get_token } from "@/utils/constants/constants.js";
import alert_mixin from "@/utils/mixins/alert_mixin";
import array_utils_mixin from "@/utils/mixins/array_utils_mixin";
import data_transform_mixin from "@/utils/mixins/data_transform_mixin";
import text_utils_mixin from "@/utils/mixins/text_utils_mixin";
import section_meta_mixin from "@/utils/mixins/section_meta_mixin";
import table_utils_mixin from "@/utils/mixins/table_utils_mixin";
import form_operations_mixin from "@/utils/mixins/form_operations_mixin";
import error_validation_mixin from "@/utils/mixins/error_validation_mixin";
import job_profile_modal_mixin from "@/utils/mixins/job_profile_modal_mixin";
import sub_entity_assignment_mixin from "@/utils/mixins/sub_entity_assignment_mixin";
import api_payload_mixin from "@/utils/mixins/api_payload_mixin";
import SubEntities from "@/views/probaworkflows_base/management/entity_management/manage_sub_entities/SubEntities.vue";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import manageEntityTypeCreateModalMixin from "./manage_entity_type_create_modal_mixin";
import manageEntityTypeCreateWorkflowMixin from "./manage_entity_type_create_workflow_mixin";
import manageEntityTypePersistenceMixin from "./manage_entity_type_persistence_mixin";
import manageEntityTypeJobProfileActionsMixin from "./manage_entity_type_job_profile_actions_mixin";
import manageEntityTypeArchiveAssignmentMixin from "./manage_entity_type_archive_assignment_mixin";

export default {
  name: "ManageEntityType",
  components: {
    CreateAdvertModal,
    EditAdvertModal,
    ViewJobProfile,
    ManageJobProfilesList,
    job_preview_modal,
    SubEntities,
    NavigationBackButton,
  },
  mixins: [
    alert_mixin,
    array_utils_mixin,
    data_transform_mixin,
    text_utils_mixin,
    section_meta_mixin,
    table_utils_mixin,
    form_operations_mixin,
    error_validation_mixin,
    job_profile_modal_mixin,
    sub_entity_assignment_mixin,
    api_payload_mixin,
    manageEntityTypeCreateModalMixin,
    manageEntityTypeCreateWorkflowMixin,
    manageEntityTypePersistenceMixin,
    manageEntityTypeJobProfileActionsMixin,
    manageEntityTypeArchiveAssignmentMixin,
  ],
  data: () => ({
    headers: get_headers(),
    trust_type_name: "",
    trust_type_description: "",
    job_profile_file: null,
    create_entity_type_id: null,
    is_extracting_ai: false,
    has_extraction_preview: false,
    create_job_title: "",
    create_job_description: "",
    create_job_requirements: "",
    create_job_key_duties: "",
    create_job_sections: [],
    create_active_section_index: 0,
    create_new_section_title: "",
    create_modal_stage: "create",
    extraction_progress_steps: [
      { label: "Backend response received — raw_payload.text present", status: "wait" },
      { label: "7 pages of text extracted from document", status: "wait" },
      { label: "Parsing sections A through J from flat text…", status: "wait" },
      { label: "Cleaning broken column words & page markers", status: "wait" },
      { label: "Structuring responsibilities, outputs & competencies", status: "wait" },
      { label: "Populating 10 editor section cards", status: "wait" },
    ],
    extraction_current_step: 0,
    reference_number: "",
    closing_date: "",
    published_date: "",
    vacancies: null,
    visibility: JOB_VISIBILITY_PRIVATE,
    trust_type_count: 0,
    trust_types: [],
    trust_types_headers: [],
    table_safe_trust_types: [],
    edit_trust_type_name: "",
    edit_trust_type_description: "",
    edit_trust_type_id: null,
    edit_reference_number: "",
    edit_closing_date: "",
    edit_published_date: "",
    edit_vacancies: null,
    edit_visibility: JOB_VISIBILITY_PRIVATE,
    token: get_token(),
    project_id: sessionStorage.getItem("project_id"),
    active_sub_program_id: sessionStorage.getItem("sub_program_id") || null,
    active_sub_program_name: sessionStorage.getItem("sub_program_name") || null,
    active_tab: "Job Profiles",
    tabs: ["Job Profiles"],
    selected_subentity: "",
    selected_subentities: [],
    sub_entities: [],
    subentity_options: [],
    show_subentities_section: false,
    new_subentities: [""],
    current_form: { parent_id: null, parent_name: "", child_id: "" },
    available_children: [],
    show_assign_modal: false,
    all_children: [],
    assign_datatable: null,
    datatable_key: 0,
    table_render_key: 0,
    assign_job_modal_sub_programs: [],
    assign_job_modal_selected_sub_program_ids: [],
    assign_job_modal_entity_type_id: null,
    selected_row: { id: "", entity_type: "" },
    create_advert_open_nonce: 0,
    selected_advert: null,
    edit_advert_open_nonce: 0,
    selected_job_action_id: null,
    selected_job_action_name: "",
    open_job_action_menu_id: null,
    archive_job_profile_id: null,
    archive_job_profile_name: "",
    archive_job_profile_loading: false,
    view_job_entity_type_id: null,
    view_job_profile_meta: {},
    view_job_profile_drawer_expanded: false,
    view_job_stats_request_id: 0,
    view_job_title: "",
    view_job_sections: [],
    view_active_section_index: 0,
    new_section_title: "",
    view_mode: "preview",
    parsed_job_id: null,
    parsed_document: null,
    parsed_raw_text: null,
    parsed_active_section: "meta",
    parsed_dirty_sections: {},
    parsed_save_state: "idle",
    parsed_save_message: "",
    parsed_save_timer: null,
    parsed_autosave_timer: null,
    parsed_drag_context: null,
    parsed_editor_mode: "split",
    parsed_history: [],
    parsed_history_index: -1,
    parsed_responsibility_index: 0,
  }),
  computed: {
    should_show_programme_back_button() {
      return Boolean(this.project_id);
    },
    programme_back_label() {
      return "Back to Programmes";
    },
  },
  mounted() {
    this.setup_assign_modal_events();
    this.setup_create_modal_events();
    this.setup_create_advert_modal_events();
    this.setup_edit_advert_modal_events();
    this.setup_view_profile_modal_events();
    this.setup_edit_profile_modal_events();
  },
  created() {
    const is_sub_program_context = sessionStorage.getItem("sub_program_context") === "1";
    if (!is_sub_program_context) {
      this.active_sub_program_id = null;
      this.active_sub_program_name = null;
      sessionStorage.removeItem("sub_program_id");
      sessionStorage.removeItem("sub_program_name");
      sessionStorage.removeItem("sub_program_context");
    }
    this.entity_type_id = sessionStorage.getItem("entity_type_id");
    this.view_created_trust_type();
  },
  methods: {
    /** Clear selected programme state before returning to the programme list. */
    clear_selected_programme_context() {
      sessionStorage.removeItem("project_id");
      sessionStorage.removeItem("company_name");
      sessionStorage.removeItem("sub_program_id");
      sessionStorage.removeItem("sub_program_name");
      sessionStorage.removeItem("sub_program_context");
      sessionStorage.removeItem("entity_type_id");
      sessionStorage.removeItem("selected_programme_return_path");
    },
    /** Return from selected programme Job Profiles to the programme list. */
    go_back_to_programme() {
      this.clear_selected_programme_context();
      this.project_id = null;
      this.active_sub_program_id = null;
      this.active_sub_program_name = null;
      sessionStorage.setItem("sidebar_active_item_key", "hardcoded:company_management");
      this.$router.replace({ name: "company_management" });
    },
  },
};
